import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import { AuthService } from '../auth.service';
import { MatCard, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatFormField, MatInput, MatError } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [MatCard, MatCardContent, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatError, MatCardActions, MatButton]
})
export class LoginComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private snackbarService: SnackbarService
  ) {}

  loginForm: UntypedFormGroup;

  isLoggedIn = false;
  roles: string[] = [];

  invalidLogin = false;
  ngOnInit(): void {
    this.loginForm = new UntypedFormGroup({
      username: new UntypedFormControl(null, [Validators.required]),
      password: new UntypedFormControl(null, [Validators.required]),
    });
  }

  loginUser(): void {
    this.authService
      .loginUser(
        this.loginForm.controls.username.value,
        this.loginForm.controls.password.value
      )
      .subscribe(
        () => {
          this.router.navigate(['/requests']);
        },

        (error: any) => {
          if (error.status === 401) {
            this.snackbarService.openErrorMessage('Wrong username or password');
          } else {
            this.snackbarService.openError(error.status);
          }
        }
      );
  }
}
